export default __webpack_public_path__ + "static/media/upload.cb774412.svg";